// 该文件仅存放用户状态相关的类型(用户级别)
// 如果是用户级别和账户级别都用到的类型, 建议放在customer中
import { EntityType, type LicenseType } from 'types/customer';

// web/user/status接口中account的status类型
export type AccountStatusType = 'UNACCOUNT' | 'OPENED' | 'FUNDED';
// web/user/status接口中account的accountType类型
// 账户类型: virtual是虚拟账户(个人中心中实际用不到, 但是接口中有这个类型)
export type AccountType = 'fd' | 'nd' | 'bs' | 'virtual';

// 持牌地
export type DomainRegion = 'SGP' | 'AUS' | 'CHN' | 'NZL';

/**
 * 账户的 customerType 类型
 */
export enum AccountCustomerTypeEnum {
    /** 個人, 0 */
    INDIVIDUAL = 0,
    /** 美国ira账户类型, 11 */
    IRA_ROTH = 11,
    /** 美国ira账户类型, 14 */
    IRA_ROLLOVER = 14,
    /** 美国ira账户类型, 15  */
    IRA_TRADITIONAL = 15,
    /** FFA, 100 */
    FFA = 100,
    /** 独立投资组合公司, 101 */
    SPC = 101,
    /** 可豁免合伙企业, 102 */
    ELP = 102,
    /** 单一基金, 103 */
    STAND_ALONE = 103,
    /** 独立交易, 106 */
    PTGM = 106,
    /** 普通公司, 107 */
    SB = 107,
    /** 期权托管, 108 */
    ESOP = 108,
    /** 家族信托, 109 */
    FAMILY_TRUST = 109,
    /** 退休信托计划, 110 */
    SUPERANNUATION_TRUST = 110,
    /** 员工集合信托, 111 */
    EMPLOYEE_TRUST_FUND = 111,
    /** 单位信托, 112 */
    UNIT_TRUST = 112,
    /** 介绍经纪人, 113 */
    INTRODUCTION_BROKER = 113,
    /** 财务顾问, 114 */
    FA = 114,
    /** 基金经理人 (即 EAM ）, 115 */
    FUND_MANAGER = 115,
    /** Employee Track / 合规官员, 116 */
    ET = 116
}

export type AccountClearingType = 'ib' | 'marsco';
export type CategoryType = 'Individual' | 'IRA';

// /api/v2/web/user/status接口返回的具体账户的数据结构类型
// 接口中有些字段没有值, 都会返回null
// 为了兼容老代码和表示方便, 在该项目中的类型中, 对于可能为null的字段, 都用可选属性表示, 即undefined
export interface AccountItemType {
    accountId: number;
    accountType: AccountType;
    customerId: number;
    hasTradePermission: 0 | 1; // 0 没有 1 有
    /**  ib账户的u码, 同br_id */
    ibAccount: string;
    isLinkFA: 0 | 1; // 0:未关联 1:关联 [是否是被fa托管账户]
    license?: LicenseType;
    status: AccountStatusType;
    category: CategoryType;
    customerType: AccountCustomerTypeEnum;
    /** 清算类型 */
    clearing?: AccountClearingType;
    entityId: EntityType; // 多租户 entity 标志
}
// /api/v2/web/user/status接口返回的数据类型(仅定义个人中心中有用的数据类型)
export interface ApiWebUserDataType {
    actualAccountInfo: {
        accountList: AccountItemType[];
        currentCustomerId?: number; // 当前账户的customer_id
    };
    currentAccountType: AccountType;
    // 只返回currentCustomerId对应的交易权限, 如果需要其他customer_id对应的权限, 有专门的接口获取@任建军
    tradePermission?: string[]; // 已开通的交易权限的数组
    userInfo: {
        email?: string; // 邮箱
        emailActive: boolean; // 邮箱是否激活
        inviteCode: string; // 本人的邀请码
        loginPassword: boolean; // 是否设置了登录密码
        phone?: string; // 手机号
        region?: string; // 用户所在地
        telCode?: string; // 手机区号
        tradePassword: boolean; // 是否设置了交易密码
        username: string;
        uuid: number; // 跟user_id一一对应的id, 用户级别的id, 注册就有
    };
}

// WebUserDataType中只存放用户状态相关的(用户级别的), 由/web/user/status接口拿到的, 或者由/web/user/status衍生而出的数据
// 其他数据不建议放在这个类型下, 不然越改越大难以维护
// !!!!!加属性, 一定要加注释, 说明该属性的作用和来源(源自哪个接口或者由某些属性计算而来等)!!!!!
export interface WebUserDataType extends ApiWebUserDataType {
    // 当前账户信息, 来源: 通过/web/user/status衍生计算得到
    currentAccount: AccountItemType;
}

// /api/v1/user/notification接口返回的数据类型
// 代表的是用户级别的通知内容
export type ApiUserNotificationType = ApiUserNotificationItem[];

export type NotificationType =
    | 'ongoing'
    | 'sg_ongoing'
    | 'ecdd'
    | 'sg_ecdd'
    | 'w8'
    | 'car'
    | 'cka'
    | 'fa_multiple_bs_accounts'; // FA邀请客户开通第二个户

export interface ApiUserNotificationItem {
    user_id: number;
    customer_id: number | null; // type是fa_multiple_bs_accounts，接口返回的customer_id为null
    type: NotificationType;
    // 额外参数，可扩展
    extra?: {
        fa_name?: string; // FA邀请客户开通第二个户的FA的名称
        sub_account_application_id?: number;
    };
}
